import { render, staticRenderFns } from "./BrickDropdownMenu.vue?vue&type=template&id=34d436a3&scoped=true&"
import script from "./BrickDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./BrickDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./BrickDropdownMenu.vue?vue&type=style&index=0&id=34d436a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d436a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d436a3')) {
      api.createRecord('34d436a3', component.options)
    } else {
      api.reload('34d436a3', component.options)
    }
    module.hot.accept("./BrickDropdownMenu.vue?vue&type=template&id=34d436a3&scoped=true&", function () {
      api.rerender('34d436a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/BrickDropdownMenu.vue"
export default component.exports